<mat-dialog-content class="mat-typography">
    <!--<h3>Has elegido objetos con condiciones financieras distintas.</h3>-->
    <p>Sólo se puede realizar una simulación por vez. Si necesitás simular otros objetos, deberás hacerlo por
        separado.</p>
    <!--<p>Tené en cuenta que las condiciones financieras finales surgirán de la suma total de los créditos que solicites.</p>-->
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="boton-rojo-ftyc">Ok</button>
</mat-dialog-actions>
